import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'smartWaiverRequired',
    'smartWaiverBlock',
    'layout',
    'shapeBlock',
    'trackInventory',
    'inventoryThresholdBlock',
    'contractUsage',
    'contractTime',
    'contractUsesBlock',
    'contractLengthBlock',
    'notifyOnLowStockBlock',
    'notifyOnLowStock',
    'imageField',
    'addImageBtn',
    'imageActionsBlock',
    'image'
  ];

  connect() {
    this.handleLayoutChanged();
    this.handleSmartWaiverChanged();
    this.handleTrackInventoryChanged();
    this.handleContractChanged();
    this.handleNotifyOnLowStockChanged();
    this.handleImageDisplay();
  }

  handleLayoutChanged() {
    if (!this.haslayoutTarget && !this.hasShapeBlockTarget) return;

    if (this.layoutTarget.checked) this.shapeBlockTarget.classList.remove('hidden')
    else this.shapeBlockTarget.classList.add('hidden');
  }

  handleSmartWaiverChanged() {
    if (!this.hasSmartWaiverRequiredTarget && !this.hasSmartWaiverBlockTarget) return;

    if (this.smartWaiverRequiredTarget.checked) this.smartWaiverBlockTarget.classList.remove('hidden');
    else this.smartWaiverBlockTarget.classList.add('hidden');
  }

  handleTrackInventoryChanged() {
    if (!this.hasTrackInventoryTarget && !this.hasInventoryThresholdBlockTarget) return;

    if (this.trackInventoryTarget.checked) {
      this.notifyOnLowStockBlockTarget.classList.remove('hidden');
    } else {
      this.notifyOnLowStockBlockTarget.classList.add('hidden');
      this.notifyOnLowStockTarget.checked = false
      this.handleNotifyOnLowStockChanged()
    }
  }

  handleNotifyOnLowStockChanged() {
    if (!this.hasNotifyOnLowStockTarget && !this.hasInventoryThresholdBlockTarget) return;

    if (this.notifyOnLowStockTarget.checked) this.inventoryThresholdBlockTarget.classList.remove('hidden');
    else this.inventoryThresholdBlockTarget.classList.add('hidden')
  }

  handleContractChanged = () => {
    if (!this.hasContractUsageTarget) return
    if (this.contractUsageTarget.checked) this.showContractUses();
    else if (this.contractTimeTarget.checked) this.showContractLength();
    else this.hideContract()
  }

  handleAddImage() {
    this.imageFieldTarget.click();
  }

  handleImageAdded = event => {
    if (!event.target.files.length) return

    const file = event.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = e => {
      this.imageTarget.setAttribute('src', e.target.result)
      this.imageTarget.classList.add('w-full', 'h-full')
      this.hideAddImageBtn()
    }
  }

  handleImageDisplay() {
    const imageSrc = this.imageTarget.getAttribute('data-src')
    if (!imageSrc) return;

    this.imageTarget.setAttribute('src', imageSrc)
    this.imageTarget.classList.add('w-full', 'h-full')
    this.hideAddImageBtn()
  }

  showAddImageBtn() {
    this.addImageBtnTarget.classList.remove('hidden')
    this.imageActionsBlockTarget.classList.add('hidden')
    this.imageTarget.classList.add('hidden');
  }

  hideAddImageBtn() {
    this.addImageBtnTarget.classList.add('hidden')
    this.imageActionsBlockTarget.classList.remove('hidden')
    this.imageTarget.classList.remove('hidden')
  }

  showContractUses() {
    this.contractUsesBlockTarget.classList.remove('hidden')
    this.contractLengthBlockTarget.classList.add('hidden')
  }

  showContractLength() {
    this.contractUsesBlockTarget.classList.add('hidden')
    this.contractLengthBlockTarget.classList.remove('hidden')
  }

  handleRemoveImage = () => {
    if (!confirm('Are you sure you want to remove this image?')) return; // eslint-disable-line no-alert
    this.imageFieldTarget.value = null;
    this.imageTarget.setAttribute('src', '#')
    this.showAddImageBtn()
  }

  hideContract() {
    this.contractUsesBlockTarget.classList.add('hidden');
    this.contractLengthBlockTarget.classList.add('hidden');
  }

}
